const common: Record<string, string> = {
  "site.name": "CSSBuy Spreadsheet",
  "site.tagline": "O Guia Definitivo para Compras",
  "site.description": "CSSBuy Spreadsheet é a fonte número um para listas de sellers verificados, comparações de agents e guias de compras internacionais. Acesse as melhores planilhas atualizadas.",
  "nav.home": "Início",
  "nav.articles": "Artigos",
  "nav.categories": "Categorias",
  "nav.contact": "Contato",
  "nav.about": "Sobre",
  "footer.rights": "© 2026 CSSBuy Spreadsheet. Todos os direitos reservados.",
  "footer.privacy": "Privacidade",
  "footer.terms": "Termos",
  "footer.subscribe": "Subscrever",
  "footer.stayUpdated": "Fique Atualizado",
  "footer.emailPlaceholder": "Seu e-mail",
  "footer.navigation": "Navegação",
  "footer.contact": "Contato",
  "dropdown.placeholder": "Selecione uma categoria...",
  "btn.cssbuySpreadsheet": "CSSBuy Spreadsheet",
  "btn.buyItNow": "Buy It Now",
  "btn.readMore": "Ler Mais",
  "btn.backHome": "Voltar ao Início",
  "cta.title": "Pronto para Acessar as Melhores Listas?",
  "cta.subtitle": "Milhares de sellers verificados esperando por você.",
  "social.trust": "10.000+ compradores confiam",
};

export default common;